import { useEffect, useLayoutEffect } from 'react';
import { useHistory } from 'hooks/generic/useHistory';
import { useSearchParams } from 'hooks/useSearchParams';
import { addQuery } from 'utils/generic/query-route';
import { EGlobalClassnames } from 'constants/dom/global-classnames';

export const useInitialQueryChecker = () => {
  const { terminalMode, terminalName, payments } = useSearchParams();
  const { history } = useHistory();

  useLayoutEffect(() => {
    if (terminalMode) {
      localStorage.setItem('terminalMode', 'true');
      history.push(addQuery({ terminalMode: undefined }));
    }
    const inTerminalMode = localStorage.getItem('terminalMode');
    if (inTerminalMode) {
      document.documentElement.classList.add(EGlobalClassnames.TerminalMode);
    }
  }, [terminalMode]);

  useEffect(() => {
    if (terminalName) {
      localStorage.setItem('terminalName', JSON.stringify(terminalName));
    }
  }, [terminalName]);

  useEffect(() => {
    if (payments) {
      localStorage.setItem('paymentMode', payments);
      history.push(addQuery({ payments: undefined }));
    }
  }, [payments]);
};
